module.exports = __webpack_public_path__ + "media/images/lpexpress-393eb227.svg";